import { makeStyles, Theme } from "@material-ui/core/styles";

export const allQuickWinsListStyles = makeStyles((theme: Theme) => ({
  loadMoreButtonContainer: {
    display: "grid",
    placeItems: "center",
    marginTop: "50px",
  },
  quickwinCard: {
    height: "186px",
  },
  clickableQuickWin: {
    cursor: "pointer",
  },
  listContainer: {
    marginTop: "32px",
  },
  loadMoreButton: {
    width: "130px",
    height: "43px",
    backgroundColor: "#F1F5FF",
    padding: "12px 24px",
    color: "#0344DC",
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 600,
    fontFamily: "Inter",
    margin: "auto",
    marginBottom: "35px",
    borderRadius: "100px",
    "&:hover": {
      backgroundColor: "#0344DC",
      color: "#F1F5FF",
    },
  },
}));
